<template>
  <div id="Sostenibilidad">
    <div class="container w-75">
      <img class="rounded img-fluid" src="/Logo_final.jpg" alt="">
    </div>
    <main class="main-content  justify-content-center">
      <div class="container-fluid justify-content-center">
        <div class="row mt-4 justify-content-center">
          <div class="col-sm-9">
            <div class="card h-100">
              <div class="overflow-hidden position-relative border-radius-lg bg-cover h-100">
                <span class="mask bg-gradient-dark"></span>
                <div class="card-body position-relative z-index-1 p-3 h-100">
                  <div class="d-flex flex-column h-100" style="position: static;">
                    <h4 class="text-white  font-weight-bolder mb-4 pt-2">Visión Responsable</h4>
                    <small class="text-white mb-3" style="text-align: justify;">{{ sustainability }}</small>
                    <div v-if="documents">
                      <div v-for="document in documents" :key="document.id">
                        <a target="_blank" class="text-white font-weight-bold ps-1 mb-0 icon-move-right mt-auto"
                          :href="document.file_url" v-if="document.title !== 'Política de privacidad' && document.title !== 'Política de seguridad'">
                          <span>{{ document.title }} </span>
                          <i class="fas fa-arrow-right text-sm ms-1" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "sust",
  data() {
    return {
      documents: [],
    };
  },
  props: {
    sustainability: {
      type: String,
      request: true,
    },
  },
  created() {
    this.plain
      .get(`/documents`)
      .then((response) => {
        if (response.data.length !== 0) {
          this.documents = response.data;
        } else {
          this.documents = [];
        }
        // console.log(this.documents);
      })
      .catch((err) => {
        this.documents = [];
        console.log(err);
      });
  },
};
</script>


<style lang="scss"  scoped>
main{
  position: static;
}
.col-sm-9{
  position: static;
}
.card{
  position: static;
}
.card-body{
  position: static;
}
.main-content{
  position: static;
}
.d-flex{
  position: static;
}
</style>